import React from 'react'
import { useState, useEffect } from 'react';
import { Table, Button, Typography} from 'antd';
import { getRecurringPayments } from '../../../../../api/EmiPayments';
import { useSelector } from 'react-redux';
import { CURRENCY } from '../../../../../utils/ConstantData';
import CustomAmountText from '../../../../common/CustomAmountText';
import { TabsEnum } from '../../../../../utils/Enum/ReportTabsEnum';
import { StarFilled } from "@ant-design/icons";

const RecurringPayments = ({onClickTabChange = () => { }}) => {
  const [emiData, setemitData] = useState(null);
  const { reportDetails, selectedAccountId } = useSelector(({ reportDetails }) => reportDetails);

  const columns = [
    {
      title: 'Start Date',
      dataIndex: 'startDate',
      key: 'startDate',
      width: 190,
    },
    {
      title: 'End Date',
      dataIndex: 'endDate',
      key: 'endDate',
      width: 190,
    },
    {
      title: 'Particulars',
      dataIndex: 'particulars',
      key: 'particulars',
    },
    {
      title: 'Counterparty',
      dataIndex: 'counterparty',
      key: 'counterparty',
    },
    {
      title: `Amount (${CURRENCY})`,
      dataIndex: 'amount',
      key: 'amount',
      align: 'right',
      className: 'no-wrap-column',
      render: (amount) => <CustomAmountText shouldDisplayCurrency={true} value={amount} />,
    },
    {
      title: 'Txn Count',
      dataIndex: 'transactionCount',
      key: 'transactionCount',
      render: (value, record, index) => {
        return (parseFloat(record.transactionCount) > 0 && emiData.length - 1 !== index) ? <Button style={{ paddingInline: 4 }} color="primary" variant="link" onClick={() => { onClickTabChange(TabsEnum.TRANSACTION) }}>{record.transactionCount}</Button> : value
      },
    },
    {
      title: 'Interval',
      dataIndex: 'interval',
      key: 'interval',
    },
    {
      title: 'Misses',
      dataIndex: 'misses',
      key: 'misses',
    },
  ];

  if(selectedAccountId === "all"){
    columns.unshift({
      title: "Bank Account",
      dataIndex: "accountDetails",
      key: "accountDetails",
      width: 190,
      render: value => (
        <>
        <StarFilled style={{ color: '#1890ff', marginRight: 8, marginTop: -11, fontSize: '20px' }} />
        {`${value?.bankAbbreviation} - ${value?.accountNumber.slice(8,12)} - ${value?.accountType}`}
        </>
      )
    })
  }

  useEffect(() => {

    const fetchData = async () => {
      try {
        let aggregate = selectedAccountId !== 'all'? false : true;
        let account_id = selectedAccountId !== 'all'? selectedAccountId : reportDetails?.report?.reportId;
        const response = await getRecurringPayments(account_id, aggregate, "recurringPayments");

        setemitData(response.recurringPayments);

      } catch (error) {

        console.log("ERROR", error);
      }
    }

    if (selectedAccountId) {
      fetchData();
    }
  }, [selectedAccountId]);

  return (
    <Table
      columns={columns}
      dataSource={emiData}
      pagination={{ pageSize: 100 }}
      scroll={{ x: true }}
    />
  )
}

export default RecurringPayments